var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.99 30C14.8388 30 14.6863 29.9637 14.5488 29.89L0.49625 22.39C0.19 22.2262 0 21.9087 0 21.5625V8.12497C0 7.79872 0.17 7.49622 0.4475 7.32497C0.72875 7.15497 1.07375 7.14247 1.36375 7.28997L15.4163 14.4775C15.73 14.6375 15.9275 14.96 15.9275 15.3125V29.0625C15.9275 29.3925 15.755 29.6975 15.4725 29.8662C15.3238 29.955 15.1575 30 14.99 30ZM1.875 21L14.0525 27.5V15.8862L1.875 9.65747V21Z",
    fill: "#2D3850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.01 30C14.8425 30 14.6763 29.955 14.5275 29.8662C14.245 29.6975 14.0725 29.3925 14.0725 29.0625V15.3125C14.0725 14.96 14.27 14.6375 14.5838 14.4775L28.6363 7.28997C28.9275 7.14247 29.2738 7.15497 29.5525 7.32497C29.8313 7.49497 30 7.79872 30 8.12497V21.5625C30 21.9087 29.81 22.2262 29.5038 22.39L15.4513 29.89C15.3125 29.9637 15.1613 30 15.01 30ZM15.9475 15.8862V27.5L28.125 21V9.65747L15.9475 15.8862ZM29.0625 21.5625H29.075H29.0625Z",
    fill: "#2D3850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0623 9.06341C28.9185 9.06341 28.7735 9.03091 28.636 8.96091L15.0098 1.99091L1.36355 8.96091C0.903545 9.19716 0.338545 9.01341 0.102295 8.55216C-0.132705 8.09091 0.0497952 7.52716 0.511045 7.29091L14.5835 0.103408C14.8523 -0.0328418 15.1698 -0.0328418 15.4373 0.103408L29.4898 7.29091C29.951 7.52716 30.1335 8.09216 29.8985 8.55216C29.731 8.87716 29.4023 9.06341 29.0623 9.06341Z",
    fill: "#2D3850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875 19.6875C21.3575 19.6875 20.9375 19.2675 20.9375 18.75V12.4537L7.16745 5.56371C6.70495 5.33121 6.51745 4.76746 6.7487 4.30496C6.9812 3.84246 7.5462 3.65621 8.0062 3.88621L22.2937 11.0362C22.6124 11.1962 22.8125 11.52 22.8125 11.875V18.75C22.8125 19.2675 22.3925 19.6875 21.875 19.6875Z",
    fill: "#2D3850"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.7df90fcf.svg";
export { ForwardRef as ReactComponent };